import Gallery from './Gallery';
const GalleryPage = () => {
  return (
    <>
      <div className='mb-4'>
        {/* For the gap below nav */}
        <p>For the gap below nav</p>
      </div>
      <Gallery />
    </>
  );
};

export default GalleryPage;
